import React from 'react'

export const FoodAndParkingStatus = ({ foodAndParkingStatus }) => {
    return (
        <>
            {foodAndParkingStatus == "None" ?
                <span style={{ color: "#dc3545" }}>اقدام نشده </span> : <></>

            }
            {foodAndParkingStatus == "Selecting" ?
                <span style={{ color: "#ffc107" }}>در حال رزرو</span> : <></>
            }
            {foodAndParkingStatus == "Payed" ?
                <span style={{ color: "#28a745" }}>پرداخت شده</span> : <></>
            }
            {foodAndParkingStatus == "Completed" ?
                <span style={{ color: "#2c8366ff" }}>تایید شده</span> : <></>
            }
            {foodAndParkingStatus == "RejectByAdmin" ?
                <span style={{ color: "#dc3545" }}>رد شده توسط ادمین</span> : <></>
            }
        </>
    )
}

